module.exports = __webpack_public_path__ + "static/media/background_mac.43637dc3.jpg";